module.exports = __webpack_public_path__ + "img/passport.91542d7e.png";